export default "__VITE_ASSET__DEHpKebV__"